export default "__VITE_ASSET__BNo4l5GJ__"